// All of the colors
const colorsList = [
    'kaspaGreen',
    'kaspaGreenGradient',
    'kaspaDarkGreen',
    'kaspaDarkGreenGradient',
    'blue',
    'indigo',
    'purple',
    'pink',
    'red',
    'orange',
    'yellow',
    'green',
    'teal',
    'cyan',
    'gray'
];

// List of text colors
const textColors = {
    kaspaGreen: 'text-[#4A8D83] dark:text-[#70C7BA]',
    kaspaGreenGradient: 'bg-clip-text text-transparent bg-gradient-to-r from-[#70C7BA] via-[#5BB5A8] to-[#4A8D83]',
    blue: 'text-blue-500 dark:text-blue-400',
    indigo: 'text-indigo-500 dark:text-indigo-400',
    purple: 'text-purple-500 dark:text-purple-400',
    pink: 'text-pink-500 dark:text-pink-400',
    red: 'text-red-500 dark:text-red-400',
    orange: 'text-orange-500 dark:text-orange-400',
    yellow: 'text-yellow-500 dark:text-yellow-400',
    green: 'text-green-500 dark:text-green-400',
    teal: 'text-teal-500 dark:text-teal-400',
    cyan: 'text-cyan-500 dark:text-cyan-400',
    gray: 'text-gray-500 dark:text-gray-400'
};

// List of background colors
const softBgColors = {
    kaspaGreen: 'bg-[#70C7BA]/10 dark:bg-[#4A8D83]/20',
    kaspaGreenGradient: 'bg-gradient-to-r from-[#70C7BA] via-[#5BB5A8] to-[#4A8D83]/10 dark:from-[#70C7BA] dark:via-[#5BB5A8] dark:to-[#4A8D83]/20',
    kaspaDarkGreen: 'bg-[#4A8D83] dark:bg-[#70C7BA]/20',
    kaspaDarkGreenGradient: 'bg-gradient-to-br from-[#70C7BA] via-[#5BB5A8] to-[#4A8D83] dark:from-[#4A8D83] dark:via-[#5BB5A8] dark:to-[#70C7BA]/20',
    blue: 'bg-blue-50 dark:bg-blue-900/50',
    indigo: 'bg-indigo-50 dark:bg-indigo-900/50',
    purple: 'bg-purple-50 dark:bg-purple-900/50',
    pink: 'bg-pink-50 dark:bg-pink-900/50',
    red: 'bg-red-50 dark:bg-red-900/50',
    orange: 'bg-orange-50 dark:bg-orange-900/50',
    yellow: 'bg-yellow-50 dark:bg-yellow-900/50',
    green: 'bg-green-50 dark:bg-green-900/50',
    teal: 'bg-teal-50 dark:bg-teal-900/50',
    cyan: 'bg-cyan-50 dark:bg-cyan-900/50',
    gray: 'bg-gray-50 dark:bg-gray-900/50'
};

// Get the list of all colors
export const getColorsList = () => {
    return colorsList;
};

// Get the text color class for a given color
export const getTextColor = color => {
    return textColors[color] || textColors.gray;
};

// Get the background color class for a given color
export const getBackgroundColor = color => {
    return softBgColors[color] || softBgColors.gray;
};